<template>
  <BContainer
    v-if="user"
  >
    <BRow
      class="pb-5 mx-1"
    >
      <BCol
        cols="12"
        class="px-0"
      >
        <BCard
          class="bg-transparent"
          body-class="p-0 d-flex flex-column flex-md-row min-h-300px rounded shadow-none"
        >
          <div
            class="d-flex flex-column justify-content-between flex-grow-1 px-4 pb-5"
            :style="{
              backgroundImage: `url(${require('@/assets/images/store.png')})`,
              backgroundPosition: 'right bottom',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '200px'
            }"
          >
            <BRow>

              <BCol
                class="p-2"
              >
                <div>
                  <h2 class="text-primary font-weight-bolder">
                    Good {{ greetings }}, {{ user?.name }}!
                  </h2>
                  <h6 class="h6">
                    Here's what's happening in your store and warehouse today
                  </h6>
                </div>
              </BCol>

              <BCol
                cols="12"
                class="p-2 border-bottom mt-4"
              >
                <h5 class="text-center text-md-left">
                  Purchase Orders
                </h5>
              </BCol>

              <BCol
                cols="12"
                class="px-0"
                style="border-radius: 0; border-bottom: 1px solid #dadada;"
              >
                <BRow
                  class="mx-0"
                >
                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.purchase-orders.requests', params: { requester: 'pending' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.pending"
                        title="Pending"
                        sub-title="PO Requests"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.purchase-orders.requests', params: { requester: 'pending' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.processing"
                        title="Processing"
                        sub-title="PO Requests"
                        variant="warning"
                        icon="fad fa-file-contract"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.purchase-orders.requests', params: { requester: 'histories', status: 'closed' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.closed"
                        title="Closed"
                        sub-title="PO Requests"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.purchase-orders.requests', params: { requester: 'histories', status: 'disapproved' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.disapproved"
                        title="Disapproved"
                        sub-title="PO Requests"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

              <BCol
                cols="12"
                class="px-0"
              >
                <BRow
                  class="mx-0"
                >
                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.purchase-orders.receiving', params: { receiver: 'pending' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.receiving.pending"
                        title="Receiving"
                        sub-title="PO Receiving"
                        variant="dark"
                        icon="fad fa-file"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  />

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.purchase-orders.receiving', params: { receiver: 'histories' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.receiving.received"
                        title="Received"
                        sub-title="PO Receiving"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.purchase-orders.requests', params: { requester: 'histories', status: 'canceled' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.canceled"
                        title="Canceled"
                        sub-title="PO Requests"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

            </BRow>

            <!-- <BRow>
              <BCol
                cols="12"
                class="p-2 border-bottom mt-4"
              >
                <h5 class="text-center text-md-left">
                  Inter Branch Transfers
                </h5>
              </BCol>

              <BCol
                cols="12"
                class="px-0"
              >
                <BRow
                  class="py-2 mx-0"
                  style="border-radius: 0; border-bottom: 1px solid #dadada;"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-branches.transfers', params: { transfer: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.transfers.pending"
                        title="Pending"
                        sub-title="IB Transfers"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-branches.transfers', params: { transfer: 'processing' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.transfers.processing"
                        title="Processing"
                        sub-title="IB Transfers"
                        variant="warning"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-branches.transfers', params: { transfer: 'histories', status: 'closed' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.transfers.closed"
                        title="Closed"
                        sub-title="IB Transfers"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-branches.transfers', params: { transfer: 'histories', status: 'disapproved' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.transfers.disapproved"
                        title="Disapproved"
                        sub-title="IB Transfers"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>

                </BRow>
              </BCol>

              <BCol
                cols="12"
                class="px-0"
                style="border-radius: 0; border-bottom: 1px solid #dadada;"
              >
                <BRow
                  class="py-2 mx-0"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-branches.posting', params: { poster: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.posting.pending"
                        title="Pending"
                        sub-title="IB Posting"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  />

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-branches.posting', params: { poster: 'histories' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.posting.posted"
                        title="Posted"
                        sub-title="IB Posting"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-branches.transfers', params: { transfer: 'histories', status: 'canceled' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.transfers.canceled"
                        title="Canceled"
                        sub-title="IB Transfers"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

              <BCol
                cols="12"
                class="px-0"
              >
                <BRow
                  class="py-2 mx-0"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-branches.receiving', params: { receiver: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.receiving.pending"
                        title="Pending"
                        sub-title="IB Receiving"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  />

                  <BCol
                    cols="12"
                    md="3"
                    class="mb-md-0 mb-5"
                  >
                    <router-link :to="{ name: 'po.inter-branches.receiving', params: { receiver: 'histories' }}">
                      <Card
                        :loading="fetching"
                        :count="interBranches.receiving.received"
                        title="Received"
                        sub-title="IB Receiving"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

            </BRow> -->

            <!-- <BRow>
              <BCol
                cols="12"
                class="p-2 border-bottom mt-4"
              >
                <h5 class="text-center text-md-left">
                  Inter Warehouse Transfers
                </h5>
              </BCol>

              <BCol
                cols="12"
                class="px-0"
              >
                <BRow
                  class="py-2 mx-0"
                  style="border-radius: 0; border-bottom: 1px solid #dadada;"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.transfers', params: { transfer: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.pending"
                        title="Pending"
                        sub-title="IW Transfers"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.transfers', params: { transfer: 'processing' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.processing"
                        title="Processing"
                        sub-title="IW Transfers"
                        variant="warning"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.transfers', params: { transfer: 'histories', status: 'closed' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.closed"
                        title="Closed"
                        sub-title="IW Transfers"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.transfers', params: { transfer: 'histories', status: 'disapproved' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.disapproved"
                        title="Disapproved"
                        sub-title="IW Transfers"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>

                </BRow>
              </BCol>

              <BCol
                cols="12"
                class="px-0"
                style="border-radius: 0; border-bottom: 1px solid #dadada;"
              >
                <BRow
                  class="py-2 mx-0"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.posting', params: { poster: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.posting.pending"
                        title="Pending"
                        sub-title="IW Posting"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  />

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.posting', params: { poster: 'histories' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.posting.posted"
                        title="Posted"
                        sub-title="IW Posting"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.transfers', params: { transfer: 'histories', status: 'canceled' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.canceled"
                        title="Canceled"
                        sub-title="IW Transfers"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

              <BCol
                cols="12"
                class="px-0"
              >
                <BRow
                  class="py-2 mx-0"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.receiving', params: { receiver: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.receiving.pending"
                        title="Pending"
                        sub-title="IW Receiving"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  />

                  <BCol
                    cols="12"
                    md="3"
                    class="mb-md-0 mb-5"
                  >
                    <router-link :to="{ name: 'po.inter-warehouses.receiving', params: { receiver: 'histories' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.receiving.received"
                        title="Received"
                        sub-title="IW Receiving"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

            </BRow> -->

          </div>
        </BCard>
      </BCol>
    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'
import createDate from 'moment'

import SimpleCard from '@/components/custom/SimpleCard.vue'
// import Card from '@/components/custom/Card.vue'

import { SPOfficerDashboard } from '@/services/po'

export default {

  name: 'VPOfficerDashboard',

  middleware: ['auth', 'po'],

  components: {
    SimpleCard
    // Card
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      borderRight: !this.isMobile(),
      purchaseOrders: {
        requests: {
          pending: 0,
          processing: 0,
          closed: 0,
          disapproved: 0,
          canceled: 0
        },
        receiving: {
          pending: 0,
          received: 0
        }
      },
      interBranches: {
        transfers: {
          pending: 0,
          processing: 0,
          closed: 0,
          disapproved: 0,
          canceled: 0
        },
        posting: {
          pending: 0,
          posted: 0
        },
        receiving: {
          pending: 0,
          received: 0
        }
      },
      interWarehouses: {
        transfers: {
          pending: 0,
          processing: 0,
          closed: 0,
          disapproved: 0,
          canceled: 0
        },
        posting: {
          pending: 0,
          posted: 0
        },
        receiving: {
          pending: 0,
          received: 0
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),

    greetings () {
      const currentHourOfTheDay = createDate().hour()

      if (currentHourOfTheDay >= 3 && currentHourOfTheDay < 12) {
        return 'Morning'
      } else if (currentHourOfTheDay === 12) {
        return 'Noon'
      } else if (currentHourOfTheDay > 12 && currentHourOfTheDay < 18) {
        return 'Afternoon'
      } else if (currentHourOfTheDay >= 18 && currentHourOfTheDay < 20) {
        return 'Evening'
      } else {
        return 'Night'
      }
    }
  },

  mounted () {
    if (this.user) {
      this.getStatistics()
    }
  },

  methods: {
    async getStatistics () {
      this.fetching = true
      return SPOfficerDashboard.getStatistics().then(
        ({ data }) => {
          this.purchaseOrders.requests = Object.assign(this.purchaseOrders.requests, {
            pending: data.total_pending,
            processing: data.total_processing,
            closed: data.total_closed,
            disapproved: data.total_disapproved,
            canceled: data.total_canceled
          })
          // this.purchaseOrders.receiving = Object.assign(this.purchaseOrders.receiving, {
          //   pending: data.approver_receiving_pending,
          //   received: data.approver_receiving_processed
          // })

          // this.interBranches.transfers = Object.assign(this.interBranches.transfers, {
          //   pending: data.inter_branch_transfer_total_pending,
          //   processing: data.inter_branch_transfer_total_processing,
          //   closed: 0,
          //   disapproved: data.inter_branch_transfer_total_disapproved,
          //   canceled: data.inter_branch_transfer_total_canceled
          // })
        }
      ).catch(() => {
        this.purchaseOrders = Object.assign(this.purchaseOrders, {
          requests: {
            pending: 0,
            processing: 0,
            closed: 0,
            disapproved: 0,
            canceled: 0
          },
          receiving: {
            pending: 0,
            received: 0
          }
        })

        this.interBranches.transfers = Object.assign(this.interBranches.transfers, {
          pending: 0,
          processing: 0,
          closed: 0,
          disapproved: 0,
          canceled: 0
        })
      }).finally(() => {
        this.fetching = false
      })
    }
  }
}
</script>
<style scoped>

  *.fa-square {
    position: absolute;
    transform: rotate(65deg) !important;
    font-size: 48px;
    left: 10px;
    bottom: 5px;
    color: var(--iq-warning-light);
  }

  *.font-circle {
    position: absolute;
    height: 48px;
    width: 48px;
    border: 2px solid var(--iq-warning-light);
    right: 5px;
    top: 0px;
    border-radius: 50%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  *.font-inset {
    font-size: 24px;
    color: var(--iq-warning);
  }
</style>
